import React, { useState, useEffect } from "react";
import { Form, Button, Row, Col } from "react-bootstrap";

const initialState = {
  commentId: 0,
  postId: 0,
  userId: 0,
  content: "",
};

const CommentForm = ({ onSave, initialData, readOnly, loading, setLoading }) => {
  const [comment, setComment] = useState(initialState);

  useEffect(() => {
    if (initialData) {
      setComment({ ...initialData });
    } else {
      setComment(initialState);
    }
  }, [initialData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setComment((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    onSave(comment);
    setTimeout(() => {
      setLoading(false);
    }, 2000)
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Row className="mb-3">
        <Col md={4}>
          <Form.Group controlId="postId">
            <Form.Label>Post Id</Form.Label>
            <Form.Control
              type="number"
              name="postId"
              value={comment.postId}
              onChange={handleChange}
              disabled={readOnly}
              required
            />
          </Form.Group>
        </Col>
        <Col md={4}>
          <Form.Group controlId="userId">
            <Form.Label>User Id</Form.Label>
            <Form.Control
              type="number"
              name="userId"
              value={comment.userId}
              onChange={handleChange}
              disabled={readOnly}
              required
            />
          </Form.Group>
        </Col>

        <Col md={4}>
          <Form.Group controlId="content">
            <Form.Label>Content</Form.Label>
            <Form.Control
              type="text"
              name="content"
              value={comment.content}
              onChange={handleChange}
              disabled={readOnly}
              required
            />
          </Form.Group>
        </Col>
      </Row>

      {!readOnly && (
        <Row>
          <Col>
            <Button type="submit" className="me-2"
              disabled={loading}>
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2"></span>
                  Saving...
                </>
              ) : (
                "Save"
              )}
            </Button>
            <Button
              variant="secondary"
              onClick={() => setComment(initialState)}
            >
              Clear
            </Button>
          </Col>
        </Row>
      )}
    </Form>
  );
};

export default CommentForm;
